import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { ClipboardList, BookOpen, History, Info } from "lucide-react";

const quickActions = [
  {
    title: "Nueva práctica",
    description: "Inicia una VGI completa con un paciente ficticio",
    href: "/aula/practicas/nueva",
    cta: "Empezar práctica",
    icon: ClipboardList,
  },
  {
    title: "Casos clínicos",
    description: "Explora casos precargados con VGI completa para estudiar",
    href: "/aula/casos",
    cta: "Ver casos",
    icon: BookOpen,
  },
  {
    title: "Mis prácticas",
    description: "Revisa las VGI que has completado anteriormente",
    href: "/aula/practicas",
    cta: "Ver mis prácticas",
    icon: History,
  },
];

export default function AulaDashboard() {
  const { user } = useAuth();
  const displayName = (user?.nombre || "").trim() || "estudiante";

  return (
    <div className="mx-auto max-w-5xl space-y-8 animate-fade-in">
      <header className="space-y-2">
        <h1 className="text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
          Bienvenido, {displayName}
        </h1>
        <p className="max-w-2xl text-base text-slate-600">
          Aquí practicas la Valoración Geriátrica Integral en un entorno seguro
        </p>
      </header>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {quickActions.map(({ title, description, href, cta, icon: Icon }) => (
          <Card
            key={title}
            className="flex flex-col border-violet-200/80 bg-white shadow-sm transition-shadow hover:shadow-md"
          >
            <CardHeader className="pb-3">
              <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl border border-violet-100 bg-violet-50 text-violet-700">
                <Icon className="h-5 w-5" strokeWidth={1.75} />
              </div>
              <CardTitle className="text-lg text-slate-900">{title}</CardTitle>
            </CardHeader>
            <CardContent className="flex flex-1 flex-col gap-4 pt-0">
              <p className="flex-1 text-sm leading-relaxed text-slate-600">{description}</p>
              <Button
                asChild
                className="w-full rounded-xl bg-violet-600 text-white hover:bg-violet-700"
              >
                <Link to={href}>{cta}</Link>
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>

      <div className="flex gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3.5 text-sm text-amber-950">
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-amber-600" aria-hidden />
        <p className="leading-relaxed">
          Este es un entorno de práctica. Los pacientes y consultas que crees aquí son ficticios y no
          forman parte de ningún expediente clínico real.
        </p>
      </div>
    </div>
  );
}
